import { useQuery } from '@tanstack/react-query'

import { toAgentErrorMessage } from 'features/yieldbirdWrapperAgent/api/errors'
import { reportsQueryOptions } from 'features/yieldbirdWrapperAgent/api/queries'
import { useRestErrorSnackbar } from 'providers/tanstack-query-rest/useRestErrorSnackbar'
import { DEFAULT_REFETCH_INTERVAL } from 'providers/tanstack-query/constants'

import type { ListReportsParams, Report } from 'features/yieldbirdWrapperAgent/api/types'

type UseReports = {
  count: number
  isLoading: boolean
  reports: Report[]
}

export const useReports = (params: ListReportsParams): UseReports => {
  const { data, error, isLoading } = useQuery({
    ...reportsQueryOptions(params),
    refetchInterval: DEFAULT_REFETCH_INTERVAL,
  })

  useRestErrorSnackbar(error, toAgentErrorMessage)

  return {
    count: data?.total ?? 0,
    isLoading,
    reports: data?.items ?? [],
  }
}
